import { render } from "./FrontendContainer.vue?vue&type=template&id=61bea5e3"
import script from "./FrontendContainer.vue?vue&type=script&lang=ts"
export * from "./FrontendContainer.vue?vue&type=script&lang=ts"

import "./FrontendContainer.vue?vue&type=style&index=0&id=61bea5e3&lang=scss"
script.render = render

export default script